import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
  AiOutlineClockCircle,
  AiOutlineLike,
  AiFillLike,
} from 'react-icons/ai';
import { BsBookmark } from 'react-icons/bs';

import CourseImage from '../../assets/banner-image.png';

import { toast } from 'react-toastify';

import {
  Container,
  Coursefooter,
  CourseTime,
  CourseLikes,
  BookmarkButton,
} from './style';
import {
  addContentBookmark,
  removeContentBookmark,
} from '../../services/bookmark';
import Content from '../../models/content';
import { secondsToTimeText } from '../../helpers/time';

interface ICourseProps {
  course: Content;
  onAddToList?: () => void;
}

const CourseCardItem: React.FC<ICourseProps> = ({ course, onAddToList }) => {
  const history = useHistory();
  const [addedToList, setAddedToList] = useState(course.addedToList);
  const [addedToLike, setAddedToLike] = useState(course.userLiked);

  const goToCourse = () => {
    history.push(`/courses/${course.id}`);
  };

  const addToList = async (event: React.MouseEvent) => {
    event.stopPropagation();

    if (course) {
      try {
        const shouldAddToList = !course.addedToList;

        if (shouldAddToList) {
          await addContentBookmark(course.id);
        } else {
          await removeContentBookmark(course.id);
        }

        course.addedToList = shouldAddToList;
        setAddedToList(course.addedToList);

        if (!!onAddToList) {
          onAddToList();
        }
      } catch (e) {
        toast.error('Erro ao adicionar curso aos favoritos.');
      }
    }
  };

  return (
    <Container onClick={goToCourse}>
      <div>
        <img src={course.thumbnail} alt="Course" />

        <h4>{course.title}</h4>

        <BookmarkButton onClick={e => addToList(e)}>
          <BsBookmark
            size={24}
            color="#FFF"
            className={`${addedToList && 'favorite'}`}
          />
        </BookmarkButton>
      </div>

      <Coursefooter>
        <CourseTime>
          <AiOutlineClockCircle />
          <span>{`${secondsToTimeText(course.duration)}`}</span>
        </CourseTime>
        <span className="divider" />
        <CourseLikes>
          {addedToLike ? (
            <AiFillLike color="#555" />
          ) : (
            <AiOutlineLike color="#555" />
          )}

          <span>
            {course.numberOfLikes &&
              `${course.numberOfLikes} ${
                course.numberOfLikes === 1 ? 'curtida' : 'curtidas'
              }`}
          </span>
        </CourseLikes>
      </Coursefooter>
    </Container>
  );
};

export default CourseCardItem;
